module.exports = __webpack_public_path__ + "img/ys-4.99e333c0.svg";